import type { ArrowDirection } from '../components/atomic/buttons/arrows/Arrows';
import type { SelectCharacterScreenModel } from './SelectCharacterScreenModelScreen';

export class SelectCharacterScreenController {
  constructor(private readonly model: SelectCharacterScreenModel) {}

  handleNavigate = (direction: ArrowDirection) => {
    this.model.setSelectedIndex((current) => {
      if (direction === 'left') {
        return (current - 1 + this.model.totalCharacters) % this.model.totalCharacters;
      }

      if (direction === 'right') {
        return (current + 1) % this.model.totalCharacters;
      }

      return current;
    });
  };

  handleConfirm = () => {
    this.model.onConfirm?.(this.model.selectedCharacter);
  };

  handleGoBack = () => {
    this.model.onGoBack?.();
  };
}
